export const stakingContractAddress = "0x352762e094d3D2e9E34Ef550F55a051408216006";
export const nftContractAddress = "0x15d37b4fe7d2c39446637C949b55e3f9Ccb87CBE";
export const tokenContractAddress = "0xAFa12d458DFec89402Db29142ecb81Efa9732C62";
export const ownerAddress = "0xB8F2Cf25BF6C99C6fd4845dC33f2E467ffDA7320";
export const networkDeployedTo = "44787";